import styled from 'styled-components'

export const SignInSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: ${({ theme }) => theme.borders.light};
  border-radius: 3px;
`
